module.exports = __webpack_public_path__ + "static/img/3x2.274191b5.svg";